import { STRING_VALUES } from '../../constants';
import map from '../../imgs/MapA.png'

function Placebo () {
	return (
    <center>
			<h1 className="headerText">{STRING_VALUES.PLACEBO_HEADER}</h1>
			<img alt="map image" width="85%" src={map}/>
			<p 
				style={{ fontSize:".7rem", fontStyle:"italic"}}
				title="mapCredits"
			>
				{STRING_VALUES.MAP_CREDITS}
			</p>
		</center>
	)
}

export default Placebo;